<template>
  <div
    id="element"
    class="the_header"
  >
    <div class="yoyo">
      <div class="hero-body w-full">
        <baniere />
        <session1 />
        <session2 />
        <session3 id="element3" />
        <session4 class="section4" />
        <session4Mob class="section4Mob" />
        <session5 />
        <session6 />
      </div>
      {{ trackScroll }}
    </div>
  </div>
</template>

<script>
import baniere from '../../components/cedo/accueil/baniere'
import session1 from '@/components/cedo/accueil/session1'
import session2 from '@/components/cedo/accueil/session2'
import session3 from '@/components/cedo/accueil/session3'
import session4 from '@/components/cedo/accueil/session4'
import session5 from '@/components/cedo/accueil/session5'
import session6 from '@/components/cedo/accueil/session6'
import session4Mob from '@/components/cedo/accueil/session4Mob'

export default {
  name: 'Index',
  components: {
    baniere,
    session1,
    session2,
    session3,
    session4,
    session5,
    session6,
    session4Mob
  },
  props: {
    scroll: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      temoin: null
    }
  },
  computed: {
    trackScroll: function () {
      if (this.scroll !== null) {
        this.smooth('element3')
      }
    }
  },
  mounted () {
    if (this.$route.query.solution !== undefined) {
      this.smooth('element3')
    } else {
      this.smooth('element')
    }
  },
  methods: {
    smooth (index) {
      this.scroll = null
      let element = document.getElementById(index)
      // element.scrollIntoView(true)
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/sass/variables";
  .yoyo{
      width: 100%;
      position: relative;
      background-color: #fff;
      height: 100%;
      padding: 0px 0px 0px 0px;
  }
  .hero-body{
    background-color: #ffffff;
    padding: 0px 0px 0px 0px;
  }
  .zoneFiltre{
    width:100%;
  }
  .nombre{
    font-size: 1.2em;
    padding-top: 0px;
    margin-right: 100px;
    font-weight: bold;
    width: 70%;
  }
  .bouton{
    background-color: white;
    box-shadow: 0px 0px 3px #00000014;
    width: 25%;
  }
  .bouton:hover{
    background-color: rgba(255, 255, 255, 0.658);
  }
  .graph{
    height: 500px;
  }
  .zonneG{
    background-color: white;
    box-shadow: 0px 0px 3px #00000014;
  }
  .section4Mob{
    display: none;
  }
  @media screen and (max-width: 600px){
    .section4{
      display: none;
    }
    .section4Mob{
      display: block;
    }
  }
</style>
